import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SalesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Sales",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M29.43 13.14H2c-.63 0-1.14-.51-1.14-1.14V4c0-.63.51-1.14 1.14-1.14h27.43c.63 0 1.14.51 1.14 1.14v8c0 .63-.51 1.14-1.14 1.14M3.14 10.86h25.14V5.15H3.14z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26 21.14H5.43c-.63 0-1.14-.51-1.14-1.14v-8c0-.63.51-1.14 1.14-1.14H26c.63 0 1.14.51 1.14 1.14v8c0 .63-.51 1.14-1.14 1.14M6.57 18.86h18.29v-5.71H6.57z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.57 29.14H8.86c-.63 0-1.14-.51-1.14-1.14v-8c0-.63.51-1.14 1.14-1.14h13.71c.63 0 1.14.51 1.14 1.14v8c0 .63-.51 1.14-1.14 1.14M10 26.86h11.43v-5.71H10z"
    })]
  }));
};